var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-info" },
    [
      _c(
        "el-form",
        _vm._b(
          {
            ref: "formRef",
            staticClass: "form",
            attrs: { model: _vm.form, rules: _vm.rules },
          },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品类型：", prop: "storeName" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.productType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "productType", $$v)
                    },
                    expression: "form.productType",
                  },
                },
                _vm._l(_vm.goodsTypeEnum2, function (rad) {
                  return _c(
                    "el-radio",
                    { key: rad.value, attrs: { label: rad.value } },
                    [_vm._v(_vm._s(rad.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品分类：", prop: "cateIds" } },
            [
              _c("el-cascader", {
                ref: "cateIdsRef",
                attrs: {
                  options: _vm.comData.cateIdsOption,
                  props: _vm.props,
                  clearable: "",
                },
                on: { change: _vm.getSpuCode },
                model: {
                  value: _vm.form.cateIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cateIds", $$v)
                  },
                  expression: "form.cateIds",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "展示分类：", prop: "showCateId" } },
            [
              _c("el-cascader", {
                attrs: {
                  options: _vm.comData.showCateIdOption,
                  props: Object.assign({}, _vm.props, { multiple: true }),
                  clearable: "",
                },
                model: {
                  value: _vm.form.showCateId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "showCateId", $$v)
                  },
                  expression: "form.showCateId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "SPU名称：", prop: "storeName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入商品名称" },
                on: { change: _vm.getSpuCode },
                model: {
                  value: _vm.form.storeName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "storeName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.storeName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "商品轮播图：",
                prop: "sliderImages",
                rules: [
                  {
                    required: true,
                    message: "请至少上传三张商品图片",
                    trigger: "submit",
                  },
                  { validator: _vm.validateSliderImages, trigger: "submit" },
                ],
              },
            },
            [
              _c(
                "div",
                { staticClass: "slider-images" },
                [
                  _vm.form.sliderImages
                    ? _c(
                        "SortImgVue",
                        {
                          attrs: {
                            imgUrlList: _vm.form.sliderImages,
                            changeList: _vm.changeSliderImages,
                          },
                        },
                        [
                          _vm.form.sliderImages &&
                          _vm.form.sliderImages.length < 10
                            ? _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                                on: { click: _vm.upLoadSliderImages },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-alert", {
                    staticClass: "image-upload-tip",
                    attrs: {
                      closable: false,
                      title: "建议上传分辨率为800×800px的图片，大小≤1000KB",
                      type: "warning",
                      "show-icon": "",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品状态：", prop: "isShow" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.isShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "isShow", $$v)
                    },
                    expression: "form.isShow",
                  },
                },
                _vm._l(_vm.goodsStatusEnum, function (rad) {
                  return _c(
                    "el-radio",
                    {
                      key: rad.value,
                      attrs: { label: rad.value, disabled: true },
                    },
                    [_vm._v(_vm._s(rad.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.productType === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "授权接收卡密：", prop: "authMsg" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.authMsg,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "authMsg", $$v)
                        },
                        expression: "form.authMsg",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#999" } }, [
                    _vm._v("如选择是，在商品下单后将弹出接收卡密信息的通知"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "品牌：", prop: "brandIdObj" } },
            [
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择",
                      filterable: "",
                      remote: "",
                      size: "small",
                      "value-key": "brandName",
                      clearable: "",
                    },
                    on: { change: _vm.getSpuCode },
                    model: {
                      value: _vm.form.brandIdObj,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "brandIdObj", $$v)
                      },
                      expression: "form.brandIdObj",
                    },
                  },
                  _vm._l(_vm.comData.brandList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.brandName, value: item },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "mr10",
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handlerOpenEdit(0)
                      },
                    },
                  },
                  [_vm._v("新增品牌")]
                ),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "SPU编码：", prop: "spuCode" } },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.form.spuCode,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "spuCode",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.spuCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.productType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "运费模板：", prop: "tempId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        disabled: "",
                      },
                      model: {
                        value: _vm.form.tempId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "tempId", $$v)
                        },
                        expression: "form.tempId",
                      },
                    },
                    _vm._l(_vm.comData.shippingList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "进项税率：", prop: "taxKey" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.taxKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "taxKey", $$v)
                    },
                    expression: "form.taxKey",
                  },
                },
                _vm._l(_vm.comData.taxKeyEnum, function (opt) {
                  return _c("el-option", {
                    key: opt.id,
                    attrs: { value: opt.id, label: opt.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.productType === 1,
                  expression: "form.productType === 1",
                },
              ],
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "产地：" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.comData.citys,
                      props: Object.assign({}, _vm.props, {
                        checkStrictly: true,
                      }),
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.areaId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "areaId", $$v)
                      },
                      expression: "form.areaId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品属性：" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.productAttr,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "productAttr", $$v)
                        },
                        expression: "form.productAttr",
                      },
                    },
                    _vm._l(_vm.comData.productAttrEnum, function (rad) {
                      return _c(
                        "el-checkbox",
                        { key: rad.id, attrs: { label: rad.id } },
                        [_vm._v(_vm._s(rad.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showDocumentProof
                ? _c(
                    "el-form-item",
                    { attrs: { label: "资料证明：" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "document-upload",
                          attrs: {
                            action: "",
                            "http-request": _vm.handleDocumentUpload,
                            "file-list": _vm.documentationFiles,
                            "on-preview": _vm.handlePreviewDocument,
                            "on-remove": _vm.handleRemoveDocument,
                            multiple: "",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [
                              _vm._v(
                                "请上传相关资质证明文件，支持PDF、Word、Excel等多种格式"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌是否授权：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.isBrandAuthorize,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isBrandAuthorize", $$v)
                        },
                        expression: "form.isBrandAuthorize",
                      },
                    },
                    _vm._l(_vm.brandAuthEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货时间：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "delivery-time",
                      on: { change: _vm.deliveryTimeChange },
                      model: {
                        value: _vm.form.deliveryTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "deliveryTime", $$v)
                        },
                        expression: "form.deliveryTime",
                      },
                    },
                    _vm._l(_vm.deliveryTimeEnum2, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_c("span", [_vm._v(_vm._s(rad.label))])]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.productType === 2,
                  expression: "form.productType === 2",
                },
              ],
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品属性：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.rechargeAttr,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rechargeAttr", $$v)
                        },
                        expression: "form.rechargeAttr",
                      },
                    },
                    _vm._l(_vm.couponsGoodsAttrsEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "账号类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.accountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "accountType", $$v)
                        },
                        expression: "form.accountType",
                      },
                    },
                    _vm._l(_vm.accountTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "充值类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.rechargeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rechargeType", $$v)
                        },
                        expression: "form.rechargeType",
                      },
                    },
                    _vm._l(_vm.rechargeTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("CreatTemplatesVue", {
        ref: "creatTemplatesVueRef",
        on: { getList: _vm.getShippingList },
      }),
      _vm._v(" "),
      _c("EditStorebrand", {
        ref: "EditStorebrandRef",
        attrs: { defaultProductType: 1, "default-status": 1 },
        on: { doRefresh: _vm.handlerGetListData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }